
const formatPriceWithCommas = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const PriceInput = ({ label='', labelClass='', inputClass='', placeholder='', value, onChange }) => {
  const handleChange = (e) => {
    const { value } = e.target;
    const numericValue = value.replace(/,/g, "").replace(/-/g, "").replace(/\D/g, ""); // Remove commas to get the numeric value
    if (!isNaN(numericValue)) {
      onChange(numericValue);
    }
  };

  const displayValue = formatPriceWithCommas(value);

  return (
    <>
      <label className={labelClass}>{label}</label>
      <div className="input-group mb-1">
        <input
          type="text"
          id={label}
          className={inputClass}
          placeholder={placeholder}
          value={displayValue}
          onChange={handleChange}
        />
        <div className="input-group-append border-left-0 rounded-0">
          <span className="input-group-text bg-transparent rounded-0 rounded-end" id="basic-addon2">UZS</span>
        </div>
      </div>
    </>
  );
};

export default PriceInput;
